import { useSelector } from 'react-redux';
import {
  selectFeatureFlag,
  selectFeatureFlagsLoaded,
} from '../data/featureFlags/selectors';

// (fail-closed: OFF when missing or the bootstrap fetch failed).
// `loaded` lets callers wait for flags to resolve before acting (e.g. gating a
// container swap). Re-renders on loaded false -> true.
const useFeatureFlag = (dbVar, defaultValue = false) => {
  const value = useSelector(selectFeatureFlag(dbVar, defaultValue));
  const loaded = useSelector(selectFeatureFlagsLoaded);

  return [value, loaded];
};

export default useFeatureFlag;
